import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["brand", "toggler", "tab"]

  connect() {
    if (!window.ResizeObserver) return

    // ponytail: hysteresis width — the loop was hide→fits→show→wraps→hide forever
    this.hiddenAtWidth = null
    this.observer = new ResizeObserver(() => this.#check())
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  // outlet API: called by sortable_controller via the navbar outlet
  hide() {
    this.element.classList.add("d-none")
  }

  // outlet API: called by sortable_controller via the navbar outlet
  show() {
    this.element.classList.remove("d-none")
  }

  #check() {
    const width = this.element.clientWidth

    // stay hidden until the navbar grows past the width where tabs last wrapped
    if (this.hiddenAtWidth !== null && width <= this.hiddenAtWidth) return

    // show to measure — this show/hide is synchronous, so it never paints a flicker
    this.#toggle(false)
    if (this.#wraps()) {
      this.#toggle(true)
      this.hiddenAtWidth = width
    } else {
      this.hiddenAtWidth = null
    }
  }

  #wraps() {
    return this.brandTarget.getBoundingClientRect().bottom < this.togglerTarget.getBoundingClientRect().bottom
  }

  #toggle(hidden) {
    this.tabTargets.forEach(t => {
      t.classList.toggle("d-none", hidden)
    })
  }
}
